import { isAppEnvironment, isSamsungBrowser, mapElements } from "../util/Utils";
import { eventQBus } from "../types/EventQBus";
import { filterSheetButton } from "../filtersheet/Selectors";
import { isMobile } from "../util/Breakpoint";
import { events } from "../events";

let buttons: QuickFilterButton[];
const VISIBILITY_OFFSET_FALLBACK = 200;

export class QuickFilterButton {
  private readonly visibilityOffset: number;
  private readonly handler: EventListener;

  private constructor(private readonly elem: HTMLElement) {
    this.visibilityOffset = QuickFilterButton.calculateVisibilityOffset();
    this.handler = () => this.setVisibility();
  }

  public static create(elem: HTMLElement) {
    const button = new QuickFilterButton(elem);
    button.init();
    return button;
  }

  public addScrollListener() {
    window.addEventListener("scroll", this.handler);
    return this;
  }

  public removeScrollListener() {
    window.removeEventListener("scroll", this.handler);
    return this;
  }

  private init() {
    this.setVisibility(); /*                     */
  }

  private setVisibility() {
    const scrollpos = window.scrollY;
    let shouldHide = true;
    if (isMobile()) {
      shouldHide = scrollpos < this.visibilityOffset;
    }

    if (this.elem.hidden !== shouldHide) {
      this.elem.hidden = shouldHide;
    }
  }

  private static calculateVisibilityOffset() {
    const element = filterSheetButton();
    if (element) {
      const visibilityOffset = element.getBoundingClientRect().bottom;
      return visibilityOffset <= 0 ? VISIBILITY_OFFSET_FALLBACK : visibilityOffset;
    }
    return VISIBILITY_OFFSET_FALLBACK;
  }
}

export function registerQuickFilterButtonHandlers() {
  const isApp = isAppEnvironment();
  if (!isApp) {
    events.onFilterSectionLoaded(onFilterSectionLoaded);
    events.onFilterSectionLoad(onFilterSectionLoad);
  }
  eventQBus.on("ftfind.tile.compared", increaseBottomSpace);
  eventQBus.on("reptile.comparison.opened", increaseBottomSpace);
  eventQBus.on("ftfind.comparison.canceled", decreaseBottomSpace);
  eventQBus.on("reptile.comparison.closed", decreaseBottomSpace);
  increaseBottomSpaceForSamsung();
}

function onFilterSectionLoad() {
  buttons.map((button) => button.removeScrollListener());
}

function increaseBottomSpace() {
  document.body.classList.add("extraBottomSpace");
}

function decreaseBottomSpace() {
  document.body.classList.remove("extraBottomSpace");
}

function increaseBottomSpaceForSamsung() {
  if (isSamsungBrowser() && !isAppEnvironment()) {
    document.body.classList.add("extraBottomSpace");
  }
}

function onFilterSectionLoaded() {
  buttons = mapElements(".js_san_quickFilter_button", QuickFilterButton.create).map((button) =>
    button.addScrollListener(),
  );
}
